module.exports = __webpack_public_path__ + "static/Mailmerge-mla.342d5a2f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/Mailmerge-mla.jpg
// module id = 502
// module chunks = 172546399187757